var alignment_rtlignore_default = {
  "alignLeft": "ZbzbY",
  "textWrapNowrap": "_39iOC",
  "alignRight": "XIZAu",
  "alignCenter": "la-jL",
  "sizeFullWidth": "IUcn0",
  "renderedInTable": "ZuYkA",
  "sizeOriginal": "M7nOP",
  "sizeContent": "RQr5R",
  "sizeSmall": "ivTGu",
  "sizeSmallCenter": "_8DeHC",
  "flex": "_-5vCP",
  "LEFT": "FNcXq",
  "CENTER": "LpSOl",
  "RIGHT": "e5ppy",
  "AUTO": "TljUW",
  "JUSTIFY": "FXNbv"
};
export {
  alignment_rtlignore_default as default
};
//# sourceMappingURL=alignment.rtlignore-scss.js.map
